import {
    THREAT_INTELLIGENCE_LIST_REQUESTED,
    THREAT_INTELLIGENCE_LIST_PROCESSING,
    THREAT_INTELLIGENCE_LIST_SUCCESSED,
    THREAT_INTELLIGENCE_LIST_FAILED,
    IMPORT_ADVISORY_SUCCESSED,
    IMPORT_ADVISORY_FAILED
  } from '../../constants/actionTypes';
  
  const initialState = {
    data: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
    isImportSuccess: false,
  };
   
  export const threatIntelligenceStore = (state = initialState, action) => {
    switch (action.type) {
      case THREAT_INTELLIGENCE_LIST_REQUESTED: {
        return {
          ...state,
          result: null,
          error: null,
          loading: true,
          requested: true,
        };
      }
      case THREAT_INTELLIGENCE_LIST_PROCESSING: {
        return {
          ...state,
          result: null,
          error: null,
          loading: true,
          requested: false,
        };
      }
      case THREAT_INTELLIGENCE_LIST_SUCCESSED: {
        return {
          result: action.data,
          error: null,
          loading: false,
          requested: false,
        };
      }
      case THREAT_INTELLIGENCE_LIST_FAILED: {
        return {
          result: null,
          error: action.data,
          loading: false,
          requested: false,
        };
      }
      case IMPORT_ADVISORY_SUCCESSED: {
        return {
          ...state,
          result: null,
          error: null,
          loading: false,
          isImportSuccess: true
        };
      }
      case IMPORT_ADVISORY_FAILED: {
        return {
          result: null,
          error: action.data,
          loading: false,
          isError: true,
          isImportSuccess: false,
        };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default threatIntelligenceStore;
  